import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteAddMetadata } from "../../../data/usecases/customer-database/remote-add-metadata";
import { AddMetadata } from "../../../domain/useages/customer-database/add-metadata";
import { MetadataMaster } from "../../../domain/useages/customer-database/metadata-master";
import { RemoteMetadataMaster } from "../../../data/usecases/customer-database/remote-fetch-metadata-master";
import { RemoveMetadata } from "../../../domain/useages/customer-database/remove-metadata";
import { RemoteRemoveMetadata } from "../../../data/usecases/customer-database/remote-remove-metadata";
import Swal from "sweetalert2";
import { CustomerDatabaseStore } from "../../main/CustomerDatabaseStore";
import { CustomerMetadata } from "../../../domain/models/customer-database/customer-metadata";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface CustoerMetadataSliceInterface {
  removeMetaData: Function;
  addMetaData: Function;
  fetchMetadata: Function;
  customerMetadata: CustomerMetadata[];
  showDepartmentSegementFilter: boolean;
}

const initialState = {
  customerMetadata: [],
  showDepartmentSegementFilter: true,
};

const axiosHttpClient = AxiosHttpClient.getInstance();





export const useMetadataSlice: StateCreator<CustoerMetadataSliceInterface> = (
  set,
  get
) => ({
  ...initialState,
  removeMetaData: async (
    paylaod: RemoveMetadata.Params,
    handleClearSelectedCustomers: Function
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });
    const remoteRemoveMetaData: RemoveMetadata = new RemoteRemoveMetadata(
      `${BASE_URL}${Endpoints.REMOVE_METADATA}`,
      axiosHttpClient
    );
    let result = await remoteRemoveMetaData.remove(paylaod);
    if (result.success) {
      handleClearSelectedCustomers();
      CustomerDatabaseStore.getState().fetchCustomerData();
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: result.errors.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    }
  },
  addMetaData: async (
    paylaod: AddMetadata.Params,
    handleClearSelectedCustomers: Function
  ) => {

    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });


    const remoteAddMetaData: AddMetadata = new RemoteAddMetadata(
      `${BASE_URL}${Endpoints.ADD_METADATA}`,
      axiosHttpClient
    );
    let result = await remoteAddMetaData.add(paylaod);
    if (result.success) {
      handleClearSelectedCustomers();
      CustomerDatabaseStore.getState().fetchCustomerData();
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    } else if (result.errors) {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: result.errors.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    }
  },
  fetchMetadata: async () => {

    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });


    const remoteFetchMetaData: MetadataMaster = new RemoteMetadataMaster(
      `${BASE_URL}${Endpoints.METADATA_MASTER}`,
      axiosHttpClient
    );
    let result = await remoteFetchMetaData.fetch({});
    if (result && result.success) {
      if (result && Array.isArray(result.customerMetadatas)) {
        if (result.customerMetadatas.length === 0) {
          set(() => ({ showDepartmentSegementFilter: false }));
        } else {
          set(() => ({ showDepartmentSegementFilter: true }));
        }
        set(() => ({ customerMetadata: result.customerMetadatas }));
      } else {
   
        set(() => ({ showDepartmentSegementFilter: false }));
        set(() => ({ customerMetadata: [] })); 
      }
    }
  },
});
